export default __webpack_public_path__ + "static/media/237.2b4920a5.gif";